import React from 'react';
// @ts-ignore
import { UchiruLogo } from '@front/ui-uchi';
import { Container, Fixed, Support, SupportMail, SupportPhone, Header, Content } from './styled';
export { Link, Nav } from './styled';

const SidebarTemplate = (props: React.PropsWithChildren<{}>) => {
	return (
		<Container>
			<Fixed>
				<Content>
					<Header>
						<UchiruLogo theme="primary" />
					</Header>
					{props.children}
					<Support>
						<SupportMail href="mailto:info@uchi.ru">info@uchi.ru</SupportMail>
						<SupportPhone href="tel:88005003072">8 800 500-30-72</SupportPhone>
					</Support>
				</Content>
			</Fixed>
		</Container>
	);
};

export default SidebarTemplate;
